import { MediatorFns } from '../../../api'
import { GetVideoUrlResponse } from '../../../api/models'

const MAX_RETRIES = 2

// Fetches a mediator streaming-session URL, retrying up to MAX_RETRIES times on a 429 (rate limit) with a
// random 1-3s backoff between attempts. Takes the getStreamingUrl fn itself (not the whole MediatorFns) so
// both callers work: ErtPreprocessor passes `mediatorFns.getStreamingUrl`, and InspectPlayerForCamera passes
// the `useGetStreamingUrlFn()` hook result - both are structurally MediatorFns['getStreamingUrl'].
export const getStreamingUrlWithRetry = async (
  getStreamingUrl: MediatorFns['getStreamingUrl'],
  mediatorUrl: string,
  accessToken: string,
  retryCount = 0
): Promise<GetVideoUrlResponse> => {
  try {
    return await getStreamingUrl(mediatorUrl, accessToken)
  } catch (e) {
    const status = (e as { status?: number }).status
    if (status === 429 && retryCount < MAX_RETRIES) {
      // wait a random 1-3s before retrying
      const wait = 1000 + Math.random() * 2000
      await new Promise(resolve => setTimeout(resolve, wait))
      return getStreamingUrlWithRetry(getStreamingUrl, mediatorUrl, accessToken, retryCount + 1)
    }
    throw e
  }
}
